import React, { useEffect, useState, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { checkAuth } from "../../api/axios";

const PrivateRoute: React.FC = () => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);
  const didVerify = useRef(false);

  useEffect(() => {
    if (didVerify.current) return;
    didVerify.current = true;

    const verify = async () => {
      const authenticated = await checkAuth();
      console.log("authenticated", authenticated);
      setIsAuth(!!authenticated);
    };

    verify();
  }, []);

  if (isAuth === null) return null; // or a loading spinner

  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
